import React from 'react';
import { Button, CardGroup, Icon } from 'library';

import './FeaturedPostCard.scss';

const FeaturedPostCard = ({ image, altText, title, text, author, date, link }) => {
  return (
    <div className="FeaturedPostWrapper">
      <CardGroup title="Featured Article">
        <div className="FeaturedPostCard">
          <figure style={{ backgroundImage: `url(${image})` }}>
            <figcaption>{altText}</figcaption>
          </figure>
          <div className="FeaturedPostBody">
            <div className="FeaturedPostContent">
              <div className="FeaturedPostMeta">
                <div className="FeaturedPostAttribution">By {author}</div>
                <div className="FeaturedPostDate">{date}</div>
              </div>
              <h3>{title}</h3>
              <p>{text}</p>
            </div>
            <div className="FeaturedPostCTA">
              <Button theme="text" href={link} alt="Read more">
                Read more
                <Icon name="arrow-right" />
              </Button>
            </div>
          </div>
        </div>
      </CardGroup>
    </div>
  );
};

export default FeaturedPostCard;
